(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-contact"] && !Shopify.designMode) return;
  try {
    
  const shContactScrollToTarget = () => {
    const allowedTargets = ['#ayuda-reembolsos', '#ShContactForm'];

    if (!allowedTargets.includes(window.location.hash)) return;

    const target = document.querySelector(window.location.hash);
    if (!target) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shContactScrollToTarget, { once: true });
  } else {
    shContactScrollToTarget();
  }

  window.addEventListener('hashchange', shContactScrollToTarget);
  document.addEventListener('shopify:section:load', shContactScrollToTarget);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-tamano"] && !Shopify.designMode) return;
  try {
    
  function initializeSquishySizeGuides(scope = document) {
    const guides = scope.querySelectorAll('[data-sh-size-guide]:not([data-sh-size-ready])');

    guides.forEach((guide) => {
      guide.setAttribute('data-sh-size-ready', 'true');

      const cards = [...guide.querySelectorAll('[data-sh-size-card]')];
      const modeButtons = [...guide.querySelectorAll('[data-sh-size-mode-button]')];
      const select = guide.querySelector('[data-sh-size-select]');
      const status = guide.querySelector('[data-sh-size-status]');

      if (!cards.length || !select) return;

      cards.forEach((card) => {
        const preview = card.querySelector('[data-sh-size-preview]');
        if (preview) {
          const previewButtons = [...preview.querySelectorAll('[data-sh-size-preview-button]')];
          const previewStatus = preview.querySelector('[data-sh-size-preview-status]');

          const showPreviewSize = (button) => {
            const percent = Number(button.dataset.shSizePreviewPercent) || 100;
            card.style.setProperty('--sh-product-preview-scale', String(percent / 100));
            previewButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
            if (previewStatus) previewStatus.textContent = button.textContent.trim();
          };

          previewButtons.forEach((button) => button.addEventListener('click', () => showPreviewSize(button)));
        }

        const squeezeButton = card.querySelector('[data-sh-squeeze-button]');
        const squeezeScene = card.querySelector('[data-sh-squeeze-scene]');
        const squeezeStatus = card.querySelector('[data-sh-squeeze-status]');
        const squeezeVideo = squeezeScene?.querySelector('video');
        let squeezeTimer;

        if (!squeezeButton || !squeezeScene) return;

        const finishSqueeze = () => {
          window.clearTimeout(squeezeTimer);
          squeezeScene.classList.remove('is-playing');
          squeezeScene.hidden = true;
          squeezeScene.setAttribute('aria-hidden', 'true');
          squeezeButton.setAttribute('aria-pressed', 'false');
          if (squeezeStatus) squeezeStatus.textContent = 'Animación terminada.';
        };

        const playSqueeze = () => {
          guide.querySelectorAll('[data-sh-squeeze-button][aria-pressed="true"]').forEach((activeButton) => {
            if (activeButton !== squeezeButton) activeButton.click();
          });

          window.clearTimeout(squeezeTimer);
          squeezeScene.hidden = false;
          squeezeScene.setAttribute('aria-hidden', 'false');
          squeezeScene.classList.remove('is-playing');
          void squeezeScene.offsetWidth;
          squeezeScene.classList.add('is-playing');
          squeezeButton.setAttribute('aria-pressed', 'true');
          if (squeezeStatus) squeezeStatus.textContent = 'Reproduciendo cómo se aprieta el squishy.';

          if (squeezeVideo) {
            squeezeVideo.currentTime = 0;
            const playPromise = squeezeVideo.play();
            if (playPromise) playPromise.catch(() => finishSqueeze());
          } else {
            squeezeTimer = window.setTimeout(finishSqueeze, 1650);
          }
        };

        squeezeButton.addEventListener('click', () => {
          if (squeezeButton.getAttribute('aria-pressed') === 'true') {
            if (squeezeVideo) squeezeVideo.pause();
            finishSqueeze();
          } else {
            playSqueeze();
          }
        });

        if (squeezeVideo) squeezeVideo.addEventListener('ended', finishSqueeze);
      });

      const setUrlMode = (mode, handle) => {
        const url = new URL(window.location.href);

        if (mode === 'single' && handle) {
          url.searchParams.set('guia', handle);
        } else if (mode === 'all') {
          url.searchParams.set('guia', 'todos');
        } else {
          url.searchParams.delete('guia');
        }

        window.history.replaceState({}, '', `${url.pathname}${url.search}#guia-de-tamanos`);
      };

      const showMode = (mode, handle = '', updateUrl = false) => {
        let visibleCards = [];

        cards.forEach((card) => {
          const isFeatured = card.dataset.shSizeFeatured === 'true';
          const isSelected = card.dataset.shSizeHandle === handle;
          const shouldShow = mode === 'all' || (mode === 'featured' && isFeatured) || (mode === 'single' && isSelected);

          card.hidden = !shouldShow;
          if (shouldShow) visibleCards.push(card);
        });

        if (!visibleCards.length) {
          mode = 'featured';
          visibleCards = cards.filter((card) => card.dataset.shSizeFeatured === 'true');
          cards.forEach((card) => {
            card.hidden = card.dataset.shSizeFeatured !== 'true';
          });
        }

        guide.dataset.shSizeMode = mode;
        modeButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.shSizeModeButton === mode));
        });
        select.value = mode === 'single' ? handle : '';

        if (status) {
          if (mode === 'single' && visibleCards[0]) {
            status.textContent = `Mostrando ${visibleCards[0].dataset.shSizeTitle}.`;
          } else {
            status.textContent = `Mostrando ${visibleCards.length} comparaciones.`;
          }
        }

        if (updateUrl) setUrlMode(mode, handle);
      };

      modeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          showMode(button.dataset.shSizeModeButton, '', true);
        });
      });

      select.addEventListener('change', () => {
        if (select.value) {
          showMode('single', select.value, true);
        } else {
          showMode('featured', '', true);
        }
      });

      const requestedProduct = new URL(window.location.href).searchParams.get('guia');
      if (requestedProduct === 'todos') {
        showMode('all');
      } else if (requestedProduct && cards.some((card) => card.dataset.shSizeHandle === requestedProduct)) {
        showMode('single', requestedProduct);
      } else {
        showMode('featured');
      }

    });
  }

  initializeSquishySizeGuides();
  document.addEventListener('shopify:section:load', (event) => initializeSquishySizeGuides(event.target));

  } catch(e) { console.error(e); }
})();
})();
